import { Button, Paper } from "@material-ui/core"
import Close from "@material-ui/icons/Close"
import type { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { Header5 } from "../../atoms"

import "./fullscreen-dialog-header.styles.scss"

export interface IFullScreenDialogHeaderProps {
  onClose: () => void
  title: string
}

export function FullscreenDialogHeader(props: IFullScreenDialogHeaderProps): ReactElement {
  const { onClose, title } = props
  const { t } = useTranslation("general")

  return (
    <Paper elevation={0} square className="fullscreen-dialog-header">
      <Button onClick={onClose} variant="outlined" color="primary" className="cancel-button">
        <Close />
        {t("dialog.cancel")}
      </Button>
      <Header5>{title}</Header5>
    </Paper>
  )
}
